import { Button } from '@cian/ui-kit';

import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';

interface IFavoriteButtonProps {
  isFavorite: boolean;
  onClick?(): void;
}

export const FavoriteButton = ({ isFavorite, onClick }: IFavoriteButtonProps) => {
  return (
    <Button
      data-testid={'FavoriteButton'}
      theme={'fill_secondary'}
      size={'XS'}
      onClick={onClick}
      beforeIcon={
        isFavorite ? (
          <IconToggleHeartOn16 color={'icon-negative-default'} />
        ) : (
          <IconToggleHeartOff16 color={'icon-negative-default'} />
        )
      }
    >
      {isFavorite ? 'В избранном' : 'В избранное'}
    </Button>
  );
};
